import * as amplitude from '@amplitude/unified';
import { config } from './env';

/**
 * Amplitude: product analytics and session replay. One project per
 * environment (development, production), shared by every Slate client, so
 * the key here is whichever `ssm:fetch` materialized for this build. Local
 * builds use the development project.
 *
 * Initialized exactly once, from main.tsx, before the first render. Events
 * tracked before the SDK finishes initializing are queued, so the first
 * page's event never races it.
 */

let started = false;

export function initAmplitude(): void {
  if (started || typeof window === 'undefined') return;
  started = true;
  const key = config.amplitudeApiKey;
  if (!key) {
    console.warn('Amplitude API key missing — analytics disabled');
    return;
  }
  amplitude.initAll(key, { analytics: { autocapture: false }, sessionReplay: { sampleRate: 1 } });
}

export { amplitude };
